import { ChevronLeft, Zap, CircleUser } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

export default function ProstoHeader({ title, back = false }) {
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-40 bg-white/90 backdrop-blur-xl border-b border-slate-200 px-4 py-3">
      <div className="flex items-center gap-3">
        {back ? (
          <>
            <button
              data-testid="prosto-back-button"
              onClick={() => (window.history.state?.idx > 0 ? navigate(-1) : navigate("/prosto"))}
              className="w-9 h-9 grid place-items-center rounded-full bg-slate-100 text-slate-700 active:scale-95 transition"
            >
              <ChevronLeft size={22} />
            </button>
            <div
              data-testid="prosto-header-title"
              className="font-display text-[17px] font-bold text-slate-900 leading-tight truncate"
            >
              {title}
            </div>
          </>
        ) : (
          <>
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 grid place-items-center rounded-2xl bg-[#2F6BFF] text-white shadow-lg shadow-blue-500/25">
                <Zap size={20} className="fill-white" />
              </span>
              <span className="font-display text-xl font-extrabold text-slate-900 tracking-tight">
                ProstoApp
              </span>
            </div>
            <button
              data-testid="prosto-profile-button"
              onClick={() => toast.info("Личный профиль скоро")}
              className="ml-auto w-9 h-9 grid place-items-center rounded-full bg-slate-100 text-slate-600 active:scale-95 transition"
            >
              <CircleUser size={22} />
            </button>
          </>
        )}
      </div>
    </header>
  );
}
